import { render } from "./StepNav.vue?vue&type=template&id=5804139a"
import script from "./StepNav.vue?vue&type=script&lang=js"
export * from "./StepNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__